import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const getAllTrafficSourceConversationFilters = () => axios.get(`${getWorkspaceId()}/traffic-source/filters/list`)
const updateTrafficSourceConversationFilters = ({ slug, formData }) => axios.put(`${getWorkspaceId()}/traffic-source/${slug}/filters`, formData)
const clearTrafficSourceConversationFilters = (slug) => axios.delete(`${getWorkspaceId()}/traffic-source/${slug}/filters`)

export {
    getAllTrafficSourceConversationFilters,
    updateTrafficSourceConversationFilters,
    clearTrafficSourceConversationFilters,
}
